import type { ChatMessage } from "../../matrix/timeline";
import { isDifferentDay } from "../../lib/time";

export interface DaySeparatorItem {
  type: "day";
  ts: number;
  key: string;
}

export interface MessageItem {
  type: "message";
  message: ChatMessage;
  key: string;
}

export type TimelineItem = DaySeparatorItem | MessageItem;

/**
 * Interleave day-separator markers between messages that cross a calendar day
 * boundary. Pure function — messages must be ordered oldest-first.
 */
export function groupByDay(messages: readonly ChatMessage[]): TimelineItem[] {
  const items: TimelineItem[] = [];
  let prevTs: number | null = null;

  for (const message of messages) {
    if (prevTs === null || isDifferentDay(prevTs, message.ts)) {
      items.push({ type: "day", ts: message.ts, key: `day-${message.ts}` });
    }
    items.push({ type: "message", message, key: message.id });
    prevTs = message.ts;
  }

  return items;
}
